import { ImageLoader } from '../../../ImageLoader';
import { useLocale } from '../../../../i18n/locale';
import { getImageAssetWithLocale, imageKeys } from './imageAssets';
import { ChapterHeadline } from '../chapterComponents/ChapterHeadline';
import { ChapterText } from '../chapterComponents/ChapterText';
import { useCustomIntl } from '../../../../i18n/i18n';

export const ServicesChargingChapter = () => {
  const { locale } = useLocale();
  const { formatMessage } = useCustomIntl();

  const headlineImage = getImageAssetWithLocale(
    imageKeys.servicesCharging,
    locale,
  );

  return (
    <div>
      <div className={'row col-xs-12'}>
        <ChapterHeadline
          messageId={'userManual.chapter.services.charging.headline'}
        />
        <div
          className={
            'display-flex col-xs-12 gap-25 flex-column flex-row-md padding-0'
          }
        >
          <ChapterText
            colSize={12}
            colSizeMd={6}
            messageId={'userManual.chapter.services.charging.text'}
          />
          <div className="col-xs-12 col-md-6 margin-bottom-25">
            <ImageLoader
              src={headlineImage}
              className={'border'}
              alt={formatMessage({
                id: 'userManual.chapter.services.charging.headline',
              })}
              enlargeable
            />
          </div>
        </div>
      </div>
    </div>
  );
};
